import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-due-date-comparsion-tags',
  templateUrl: './due-date-comparison-tags.component.html',
  styleUrl: './due-date-comparison-tags.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NzToolTipModule],
})
export class DueDateComparisonTagsComponent implements OnInit {
  @Input('clickable') clickable = false;
  @Input('overdue') overdue = 0;
  @Input('today') today = 0;
  @Input('total') total = 0;
  @Output('selected') selected = new EventEmitter();

  data: {
    id: string;
    title: string;
    value: number;
    active: boolean;
  }[] = [];

  ngOnInit(): void {
    this.data = [
      {
        id: 'overdue',
        title: 'Overdue',
        value: this.overdue,
        active: true,
      },
      {
        id: 'today',
        title: 'Due today',
        value: this.today,
        active: true,
      },
      {
        id: 'total',
        title: 'Total',
        value: this.total,
        active: true,
      },
    ];
  }

  activate(id: string): void {
    if (this.clickable) {
      if (this.data.every((i) => i.active)) {
        this.data.forEach((i) => (i.active = i.id == id));
      } else {
        this.data.forEach((i) => (i.active = i.id == id ? !i.active : false));
      }

      if (this.data.every((i) => i.active)) {
        this.selected.emit('all');
      } else if (!this.data.some((i) => i.active)) {
        this.data.forEach((i) => (i.active = true));
        this.selected.emit('all');
      } else {
        this.selected.emit(id);
      }
    }
  }
}
